


































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import router from '../router';
import moment from 'moment';
import { Project } from '../../../common/project';
import { colors } from '../theme';

import * as PROJECTS_QUERY from 'src/graphql/Projects.graphql';
import * as ARCHIVE_PROJECT_QUERY from 'src/graphql/ArchiveProject.graphql';
import * as PROJECT_ARCHIVED_FRAGMENT_QUERY from 'src/graphql/ProjectArchivedFragment.graphql';

@Component({
  apollo: {
    projects: {
      query: PROJECTS_QUERY,
      fetchPolicy: 'cache-and-network',
    },
  }
})
export default class ProjectList extends Vue {
  @Prop() sortBy : string;
  @Prop() filter : string;
  @Prop() showArchived : boolean;

  projects = [];
  selected = [0]
  page = 1;
  numPages = 1;
  pageSize = 10;
  pages: Project[][] = [];
  loading = true;
  showArchivedIndex = -1;

  mounted() {
    this.loading = true;
    this.$apollo.queries.projects.refetch();
  }

  get developerMode() {
    return this.$store.state.developerMode;
  }

  @Watch('showArchived')
  onShowArchivedChanged() {
    this.page = 1;
    this.updateDisplayList();
  }

  @Watch('developerMode')
  onDeveloperModeChange() {
    console.log(`Developer mode changed, refetch project list`);
    this.loading = true;
    this.page = 1;
    this.$apollo.queries.projects.refetch();
  }

  @Watch('projects')
  onProjectsChanged(val: any[], oldVal: any[]) {
    console.log(`Received project list from server`);
    const pList = val.map(p => Project.restore(p));
    this.loading = false;
    this.$store.commit('setProjects', pList);
    this.updateDisplayList();
  }

  @Watch('sortBy')
  onSortChange() {
    this.updateDisplayList();
  }

  @Watch('filter')
  onFilterChange() {
    this.updateDisplayList();
  }

  updateDisplayList() {
    console.log(`updateDisplayList`);

    const filtered = _.filter(this.$store.state.projectList, (p) => (
     (p.owner.toLowerCase().includes(this.filter) ||
      p.name.toLowerCase().includes(this.filter) ||
      p.description.toLowerCase().includes(this.filter)) &&
      p.archived === this.showArchived
    ));

    this.numPages = Math.ceil(filtered.length / this.pageSize);

    let sorted;
    if (this.sortBy === 'Name') {
      sorted = _.orderBy(filtered, [project => project.name.toLowerCase()]);
    } else {
      sorted = _.orderBy(filtered, 'modifiedAt', 'desc');
    }

    this.pages = _.chunk(sorted, this.pageSize);
  }

  onClickProject(project) {
    if (this.showArchived)
      return;

    console.log(`click `, project);
    router.push({ path: `/${project.path}` });
  }

  onArchiveProject(project) {
    this.$apollo.mutate({
      mutation: ARCHIVE_PROJECT_QUERY,
      variables: {
        id: project.id,
        archive: !this.showArchived,
      },
      update: (store, {data: { archiveProject }}) => {
        store.writeFragment({
          id: `Project:${project.id}`,
          fragment: PROJECT_ARCHIVED_FRAGMENT_QUERY,
          data: {
            __typename: 'Project',
            archived: archiveProject,
            modifiedAt: !archiveProject ? new Date() : project.modifiedAt.toDate(),
          }
        });
      },
      optimisticResponse: {
        __typename: 'Mutation',
        archiveProject: !this.showArchived,
      },
    });

    this.showArchivedIndex = -1;
  }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProjectList.vue